import Vue from "vue";
import api from "@/common/api/api";

export default {
  namespaced: true,
  state: {
    info: {
      id: "",
      role_id: "",
      token: "",
    },
    location: uni.getStorageSync("location") || {
      // 纬度
      latitude: null,
      // 经度
      longitude: null,
    },
    currentJobPosition: null,
    showNeedResume: false, //显示需要填写简历
  },
  mutations: {
    CHANGE_PRO: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    },

    setCurrentJobPosition: (state, payload) => {
      state.currentJobPosition = payload;
    },

    SET_LOCATION: (state, { latitude, longitude }) => {
      console.log(123, latitude);
      state.location = {
        latitude,
        longitude,
      };
      uni.setStorageSync("location", {
        latitude,
        longitude,
      });
    },
    setUser(state, data) {
      // uni.setStorageSync('token', data.token);
      uni.setStorageSync("token", data.access_token);
      uni.setStorageSync("user", data);
      console.log(data);
      state.info = data;
    },

    rmUser(state) {
      state.info = {
        id: "",
        role_id: "",
        token: "",
      };
      uni.setStorageSync("user", "");
      uni.setStorageSync("token", "");
    },
  },
  actions: {
    async getUserInfo({ state, commit, dispatch }) {
      if (state.info.token) {
        let res = await api.userInfo({});
        if (!res.code) {
          commit("rmUser");
        }
        dispatch("getUserAfter", res.data);
      } else {
        commit("rmUser");
      }
    },

    async getUserAfter({ state, commit }, user) {
      let showNeedResume = false;
      user.resume = "";
      if (user.role_id == 2) {
        let res = await this.$stores.dispatch("user/getMyResume");
        if (res.code) {
          user.resume = res.data;
        } else {
          showNeedResume = true;
        }
      }
      commit("CHANGE_PRO", { showNeedResume });
      commit("setUser", user);
    },

    async getMyResume({ state, commit }) {
      let res = await Vue.$u.api.myResume({});
      let resume = "";
      if (res.code) {
        if (res.data) {
          resume = res.data;
        }
      }
      console.log(resume);
      if (resume) {
        commit("CHANGE_PRO", { key: "showNeedResume", value: false });
      }
      console.log(state.showNeedResume);

      return res;
    },
  },
};
